import * as Flux from 'dg-web-shared/lib/Flux';
import { Maybe } from 'dg-web-shared/lib/MaybeV2';

export enum SortField {
    ZoneId,
    ZoneName,
    Distance,
}

export interface State {
    open: boolean;
    openEpoch: Maybe<number>;
    sortField: SortField;
    sortAscending: boolean;
    filterValue: string;
}

export class StateSlice extends Flux.StateSlice<State> {
    key(): string {
        return 'park-create-ZoneDropinState';
    }
    sideEffects(): void {
        return;
    }

    getInitialState(): State {
        return {
            open: false,
            openEpoch: null,
            sortField: SortField.ZoneId,
            sortAscending: true,
            filterValue: '',
        };
    }

    setOpen(open: boolean): void {
        this.set((s: State): State => {
            s.open = open;
            s.openEpoch = open ? new Date().getTime() : null;
            return s;
        });
    }

    setSortField(sortField: SortField): void {
        this.set((s: State): State => {
            s.sortField = sortField;
            return s;
        });
    }

    setSortAscending(sortAscending: boolean): void {
        this.set((s: State): State => {
            s.sortAscending = sortAscending;
            return s;
        });
    }

    toggleSortAscending(): void {
        this.set((s: State): State => {
            s.sortAscending = !s.sortAscending;
            return s;
        });
    }

    setFilterValue(filterValue: string): void {
        this.set((s: State): State => {
            s.filterValue = filterValue;
            return s;
        });
    }
}

export function filterActive(s: State): boolean {
    return s.filterValue.length > 0;
}
